import React from 'react';
import { Table } from 'react-bootstrap';
import { useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import { LoggedUserContext } from '../../contexts/logged-user-context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faStore, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import lib from '../../helpers/lib';
import './styles.scss';
import '../faturamento/styles.scss';

import Layout from '../../components/layout/base';
import PageTitleCard from 'components/page-title-card';
import Select from 'react-select';
import SelectMulti from 'components/_base/multi-select';

import PedidoService from '../../services/pedido-service';
import RedeService from '../../services/rede-service';
import RelatorioService from '../../services/relatorio-service';
import RepresentadaService from '../../services/representada-service';
import LojaService from '../../services/loja-service';

export default function TopClientes({ vendedores, representadas }) {
  const [userData, _] = React.useContext(LoggedUserContext);

  const mesInicialFiltro = new Date(),
    y = mesInicialFiltro.getFullYear(),
    m = mesInicialFiltro.getMonth();
  const dataInicialFiltro = new Date(y, m, 1);
  const dataFinalFiltro = new Date(y, m + 1, 0);

  const [isLoading, setIsLoading] = React.useState(true);

  const [dataMesAnoPassado, setDataMesAnoPassado] = React.useState('');
  const [dataMesPassado, setDataMesPassado] = React.useState('');
  // const [representadas, setRepresentadas] = React.useState([]);
  const [representantes, setRepresentantes] = React.useState([]);
  const [redes, setRedes] = React.useState([]);
  const [statusSelectList, setStatusSelectList] = React.useState([]);
  const [statusSelecionado, setStatusSelecionado] = React.useState([]);
  const [pedidoTipos, setPedidoTipos] = React.useState([]);
  const [pedidoTipoSelected, setPedidoTipoSelected] = React.useState([]);
  const [regionais, setRegionais] = React.useState([]);
  const [topClientes, setTopClientes] = React.useState([]);
  const [totalClientes, setTotalClientes] = React.useState([]);

  const [filter, setFilter] = React.useState({
    codigoPedido: '',
    representadaId: null,
    vendedorId: null,
    redeId: null,
    regionalId: null,
    lojaCnpj: '',
    tipoPedidoSigla: [],
    mes: m + 1,
    ano: y,
    statusPedidos: [],
    quantidadeClientes: 30
  });

  const [loadedRepresentadas, setLoadedRepresentadas] = React.useState(false);
  const [loadedVendedores, setLoadedVendedores] = React.useState(false);
  const [loadedRegionais, setLoadedRegionais] = React.useState(false);

  useEffect(() => {
    (async () => {
      if (vendedores) {
        if (vendedores.length === 1) {
          setFilter((prevFilter) => ({
            ...prevFilter,
            vendedorId: vendedores[0]?.value
          }));
        }
        setLoadedVendedores(true);
      }
    })();
  }, [vendedores]);

  useEffect(() => {
    (async () => {
      if (representadas && representadas.length > 0) {
        setFilter((prevFilter) => ({
          ...prevFilter,
          representadaId: representadas[0]?.value
        }));
      }
      setLoadedRepresentadas(true);
    })();
  }, [representadas]);

  useEffect(() => {
    (async () => {
      if (loadedRepresentadas && loadedVendedores && loadedRegionais) {
        getTopClientes();
      }
    })();
  }, [loadedRepresentadas, loadedVendedores, loadedRegionais]);

  useEffect(() => {
    (async () => {
      // getSelectListRede();
      // getSelectListRepresentante();
      // getSelectListStatus();
      // getPedidoTipos();
      // getRepresentadas();
      await getRegionais();
    })();
  }, []);

  // useEffect(() => {
  //   (async () => {
  //     let dataMesAnoPassado = `${lib.capitalizeFirstLetter(new Date(filter.ano, filter.mes - 1, 1).toLocaleString('default', { month: 'long' }))} ${y - 1}`;
  //     setDataMesAnoPassado(dataMesAnoPassado);

  //     let dataMesPassado = `${lib.capitalizeFirstLetter(new Date(filter.ano, filter.mes - 2, 1).toLocaleString('default', { month: 'long' }))} ${y}`;
  //     setDataMesPassado(dataMesPassado);
  //   })();
  // }, [filter.ano, filter.mes]);

  useEffect(() => {
    (async () => {
      if (topClientes?.length > 0) {
        let clientesComValor = topClientes.filter((item) => item.valorMediaAnual > 0);

        let topClientesModel = {
          nomeFantasia: ' ',
          valorAnoAnterior: +topClientes
            .reduce((acc, item) => acc + item.valorAnoAnterior, 0)
            .toFixed(2),
          valorMesAnterior: +topClientes
            .reduce((acc, item) => acc + item.valorMesAnterior, 0)
            .toFixed(2),
          valorMediaAnual:
            +topClientes.reduce((acc, item) => acc + item.valorMediaAnual, 0).toFixed(2) /
            topClientes.length,
          valorMaximoMensal: Math.max(
            ...topClientes.map((item) => {
              return item.valorFaturado;
            })
          ),
          valorFaturado: +topClientes.reduce((acc, item) => acc + item.valorFaturado, 0).toFixed(2),
          valorMeta: +topClientes.reduce((acc, item) => acc + item.valorMeta, 0).toFixed(2),
          diasSemVenda: null
        };

        topClientesModel.valorRealizado =
          topClientesModel.valorFaturado - topClientesModel.valorMeta;

        topClientesModel.porcentagemRealizado =
          topClientesModel.valorMeta != 0
            ? +((topClientesModel.valorFaturado / topClientesModel.valorMeta) * 100).toFixed(2)
            : 0;
        topClientesModel.porcentagemAnoAnterior =
          topClientesModel.valorFaturado != 0
            ? +((topClientesModel.valorAnoAnterior / topClientesModel.valorFaturado) * 100).toFixed(
                2
              )
            : 0;
        topClientesModel.porcentagemMesAnterior =
          topClientesModel.valorFaturado != 0
            ? +((topClientesModel.valorMesAnterior / topClientesModel.valorFaturado) * 100).toFixed(
                2
              )
            : 0;
        topClientesModel.porcentagemMediaAnual =
          topClientesModel.valorFaturado != 0
            ? +((topClientesModel.valorMediaAnual / topClientesModel.valorFaturado) * 100).toFixed(
                2
              )
            : 0;
        topClientesModel.porcentagemMaximoMensal =
          topClientesModel.valorFaturado != 0
            ? +(
                (topClientesModel.valorMaximoMensal / topClientesModel.valorFaturado) *
                100
              ).toFixed(2)
            : 0;

        setTotalClientes([topClientesModel]);
      }
    })();
  }, [topClientes]);

  async function getTopClientes() {
    setIsLoading(true);

    let resultStatus = await RelatorioService.getTopLojas(filter);
    if (resultStatus.data) {
      setTopClientes(resultStatus.data);
    }

    setIsLoading(false);
  }

  async function getSelectListStatus() {
    let resultStatus = await PedidoService.getSelectListSiglaAsync();
    if (resultStatus.data) {
      setStatusSelectList(resultStatus.data.data);
    }
  }

  async function getSelectListRede() {
    let redes = await RedeService.getSelectList();
    if (redes.data) {
      setRedes(redes.data.data);
    }
  }

  async function getSelectListRepresentante() {
    let representantes = await PedidoService.getSelectListRepresentanteAsync();
    if (representantes.data) {
      setRepresentantes(representantes.data.data);
    }
  }

  async function getPedidoTipos() {
    const response = await PedidoService.GetPedidoTiposAsync();
    if (response?.data) {
      setPedidoTipos(response?.data?.data);
    }
  }

  async function getRepresentadas() {
    const response = await RepresentadaService.selectListAsync();
    if (response?.data) {
      setRepresentadas(response?.data?.data[0]?.options);
      setFilter({ ...filter, representadaId: response?.data?.data[0]?.options[0]?.value });
    }
  }

  async function getRegionais() {
    const response = await LojaService.listRegionaisAsync();
    if (response?.data) {
      setRegionais(response?.data?.data);
    }

    setLoadedRegionais(true);
  }

  async function getExtratoTopLojas() {
    setIsLoading(true);

    let response = await RelatorioService.getExtratoTopLojas(filter);

    if (response?.data) {
      let fileName = `faturamento_top_clientes_${lib.getCurrentDateFilename()}.xlsx`;
      lib.downloadFile(response.data.data, fileName);
    }

    setIsLoading(false);
  }

  return (
    <div>
      {/* Filter ------------------------------------------------------------------------------ */}
      <div className="row filter-bar2 mb-5">
        {/* <div className="col-xl-3 mb-3">
          <label>Pedido</label>
          <input
            type="text"
            className="form-control"
            value={filter.codigoPedido}
            onChange={(ev) => {
              setFilter({ ...filter, codigoPedido: ev.target.value });
            }}
          />
        </div>

        <div className="col-xl-3 mb-3" disabled>
          <label>Rede</label>
          <Select
            isClearable
            clearValue={() => {
              setFilter({ ...filter, redeId: null });
            }}
            styles={customControlStyles}
            placeholder="Selecione..."
            options={redes}
            value={redes?.find((x) => x.value === filter.redeId)}
            onChange={(selectedValue) => setFilter({ ...filter, redeId: selectedValue?.value })}
          />
        </div>

        <div className="col-xl-3 mb-3" disabled>
          <label>CNPJ da Loja</label>
          <input
            type="text"
            className="form-control"
            value={filter.lojaCnpj}
            onChange={(ev) => {
              setFilter({ ...filter, lojaCnpj: ev.target.value });
            }}
          />
        </div>

        <div className="col-xl-2 mb-3" disabled>
          <label>Tipo</label>
          <SelectMulti
            isClearable
            clearValue={() => {
              setPedidoTipoSelected([]);
            }}
            placeholder="Selecione..."
            options={pedidoTipos}
            value={pedidoTipoSelected}
            onChange={(options) => {
              setPedidoTipoSelected(options);
            }}
          />
        </div> */}

        <div className="col-xl-3 mb-3" disabled>
          <label>Representada</label>
          <Select
            isClearable={false}
            // clearValue={() => {
            //   setFilter({ ...filter, representadaId: null });
            // }}
            styles={customControlStyles}
            placeholder="Selecione..."
            options={representadas}
            value={representadas?.find((x) => x.value === filter.representadaId)}
            onChange={(selectedValue) =>
              setFilter({ ...filter, representadaId: selectedValue?.value })
            }
          />
        </div>

        <div className="col-xl-2">
          <label>Regional</label>
          <Select
            className="select-form-control"
            value={regionais?.find((item) => item.nome === filter.regionalId)}
            options={regionais}
            getOptionLabel={(option) => option.nome}
            getOptionValue={(option) => option.regionalId}
            placeholder="Regional"
            isClearable
            clearValue={() => {
              setFilter({ ...filter, regionalId: null });
            }}
            onChange={(item) => {
              setFilter({ ...filter, regionalId: item.regionalId });
            }}
          />
        </div>

        <div className="col-xl-3" disabled>
          <label>Vendedor</label>
          <Select
            isClearable={vendedores?.length > 1}
            clearValue={() => {
              setFilter({ ...filter, vendedorId: null });
            }}
            styles={customControlStyles}
            placeholder="Selecione..."
            options={vendedores}
            value={vendedores?.find((x) => x.value === filter.vendedorId)}
            onChange={(selectedValue) => setFilter({ ...filter, vendedorId: selectedValue?.value })}
          />
        </div>

        <div className="col-xl-2">
          <label>Mês</label>
          <Select
            className="select-form-control"
            value={lib.selectListMeses?.find((item) => item.value === filter.mes)}
            options={lib.selectListMeses}
            isClearable={false}
            onChange={(item) => {
              setFilter({ ...filter, mes: item.value });
            }}
          />
        </div>

        <div className="col-xl-2">
          <label>Ano</label>
          <Select
            className="select-form-control"
            value={lib.selectListAnos?.find((item) => item.value === filter.ano)}
            options={lib.selectListAnos}
            isClearable={false}
            onChange={(item) => {
              setFilter({ ...filter, ano: item.value });
            }}
          />
        </div>

        {/* <div className="col-xl-3 mb-3">
          <label>Status</label>
          <Select
            isClearable
            clearValue={() => {
              setFilter({ ...filter, status: [] });
            }}
            styles={customControlStyles}
            placeholder="Selecione..."
            options={statusSelectList}
            value={
              filter?.statusPedidos
                ? statusSelectList.find((x) => x.value === filter.statusPedidos)
                : []
            }
            onChange={(selectedValue) => {
              setFilter({ ...filter, statusPedidos: selectedValue?.value });
            }}
          />
        </div> */}

        <div className="col row align-content-end">
          <div className="col-xl-8"></div>

          <div className="col-xl-2 col-6  align-content-end">
            {/* Botão Exportar --------------------------------------------------------------------- */}
            <button
              type="button"
              className="btn btn-secondary btn-sm btn-action"
              onClick={() => {
                setFilter({
                  ...filter
                });
                getExtratoTopLojas();
              }}
              disabled={isLoading}
            >
              <FontAwesomeIcon icon={faFileExcel} /> Exportar
            </button>
          </div>

          <div className="col-xl-2 col-6 align-content-end">
            {/* Botão Filtrar --------------------------------------------------------------------- */}
            <button
              type="button"
              className="btn btn-secondary btn-sm btn-action"
              onClick={() => {
                setFilter({
                  ...filter,
                  tipoPedidoSigla: pedidoTipoSelected
                  //pageNumber: 1
                });
                getTopClientes();
              }}
              disabled={isLoading}
            >
              <FontAwesomeIcon icon={faFilter} /> Filtrar
            </button>
          </div>
        </div>
      </div>

      {/* Lista Lojas ----------------------------------------------------------------- */}
      <div className="table-responsive table-historico mt-4" onCopy={(e) => lib.parseCopiedText(e)}>
        {!isLoading && topClientes ? (
          <Table striped bordered hover width="100%" className="table-relatorio">
            <thead>
              <tr>
                <th>#</th>
                <th>Cliente</th>
                {/* <th>{dataMesAnoPassado}</th>
                <th>{dataMesPassado}</th> */}
                <th>Ano Anterior</th>
                <th>Mês Anterior</th>
                <th>Média 12M</th>
                <th>Máx Mensal</th>
                <th>Faturado</th>
                <th>Objetivo</th>
                <th colSpan={2} className="text-center">
                  Realizado
                </th>
                <th style={{ textAlign: 'center' }}>Dias Sem Venda</th>
                <th style={{ textAlign: 'center' }}>A. Anterior</th>
                <th style={{ textAlign: 'center' }}>M. Anterior</th>
                <th style={{ textAlign: 'center' }}>Média</th>
                <th style={{ textAlign: 'center' }}>MAX</th>
              </tr>
            </thead>
            {/* <tbody className="table-sem-totalizadores"> */}
            <tbody>
              {topClientes.length > 0 ? (
                ([...topClientes, ...totalClientes] || [])?.map((item, index) => (
                  <tr key={index} className={index >= topClientes.length ? 'fw-700' : ''}>
                    <td>{index + 1 > topClientes.length ? ' ' : index + 1}</td>
                    <td>
                      {item.nomeFantasia}
                      <span className="loja-subtitulo">{item.lojaCnpj}</span>
                    </td>
                    <td>
                      {/* {item.valorAnoAnterior.toFixed(2)} */}
                      {Math.floor(item.valorAnoAnterior).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}
                    </td>
                    <td>
                      {/* {item.valorMesAnterior.toFixed(2)} */}
                      {Math.floor(item.valorMesAnterior).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}
                    </td>
                    <td>
                      {/* {item.valorMediaAnual.toFixed(2)} */}
                      {Math.floor(item.valorMediaAnual).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}
                    </td>
                    <td>
                      {/* {item.valorMaximoMensal.toFixed(2)} */}
                      {Math.floor(item.valorMaximoMensal).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}
                    </td>
                    <td>
                      {/* {item.valorFaturado.toFixed(2)} */}
                      {Math.floor(item.valorFaturado).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}
                    </td>
                    <td>
                      {/* {item.valorMeta.toFixed(2)} */}
                      {Math.floor(item.valorMeta).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}
                    </td>
                    <td>
                      {/* {(item.valorMeta > 0 ? item.valorRealizado : 0)?.toFixed(2)} */}
                      {Math.floor(item.valorMeta > 0 ? item.valorRealizado : 0).toLocaleString(
                        'pt-br',
                        {
                          style: 'currency',
                          currency: 'BRL',
                          maximumFractionDigits: 0
                        }
                      )}
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      {lib.formatToNumeric(item.porcentagemRealizado, 2, true)}%
                    </td>
                    <td style={{ textAlign: 'center' }}>{item.diasSemVenda}</td>
                    <td style={{ textAlign: 'center' }}>
                      {lib.formatToNumeric(item.porcentagemAnoAnterior, 2, true)}%
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      {lib.formatToNumeric(item.porcentagemMesAnterior, 2, true)}%
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      {lib.formatToNumeric(item.porcentagemMediaAnual, 2, true)}%
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      {lib.formatToNumeric(item.porcentagemMaximoMensal, 2, true)}%
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={15}>Nenhum registro encontrado.</td>
                </tr>
              )}
            </tbody>
          </Table>
        ) : (
          <Skeleton count={10} />
        )}
      </div>
    </div>
  );
}
